import { ctxTachograph } from '@/contexts/TachographCtx';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

export default function TachographFileNameSelector({ isBottom }: { isBottom?: boolean }) {
  const tachographCtx = useContext(ctxTachograph);
  const { t } = useTranslation();

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    tachographCtx?.setIsCroatian(event.target.value === 'true');
  }

  return (
    <FormControl>
      <RadioGroup
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
        onChange={handleChange}
        value={tachographCtx?.isCroatian.toString()}
        sx={{
          flexDirection: { xs: 'column', sm: 'row' },
        }}
      >
        <FormControlLabel
          value="false"
          control={
            <Radio
              sx={{
                '&.Mui-checked': isBottom
                  ? { color: 'var(--mui-palette-secondary-main)' }
                  : { color: 'var(--mui-palette-primary-main)' },
              }}
              data-qa-element-id="general_file_name_radio_button"
            />
          }
          label={t('tachograph.downloadButton.generalFileName')}
        />

        <FormControlLabel
          value="true"
          control={
            <Radio
              sx={{
                '&.Mui-checked': isBottom
                  ? { color: 'var(--mui-palette-secondary-main)' }
                  : { color: 'var(--mui-palette-primary-main)' },
              }}
              data-qa-element-id="hr_file_name_radio_button"
            />
          }
          label={t('tachograph.downloadButton.hrFileName')}
        />
      </RadioGroup>
    </FormControl>
  );
}
